module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_PT-aa799da8844f41d7db3beca6fcf8db43.svg";